import {
  EditTagRequest,
  MatchedRequest,
  Tags,
  TagsPage,
  TagsRequest,
  TagsResponse,
  TagsState,
} from 'store/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { tagsAPI } from 'api/Api';

export const fetchAllTags = createAsyncThunk<
  TagsPage,
  TagsRequest,
  { rejectValue: boolean }
>('tags/fetchAllTags', async (args, { rejectWithValue }) => {
  try {
    const response = await tagsAPI.getAllTags(args);

    return response;
  } catch (e) {
    return rejectWithValue(false);
  }
});

export const fetchTopTags = createAsyncThunk<
  TagsResponse,
  null,
  { rejectValue: boolean }
>('tags/fetchTopTags', async (args, { rejectWithValue }) => {
  try {
    const response = await tagsAPI.getTopTags();

    return response;
  } catch (e) {
    return rejectWithValue(false);
  }
});

export const fetchMatched = createAsyncThunk<
  Tags,
  MatchedRequest,
  { rejectValue: boolean }
>('tags/fetchMatched', async (arg, { rejectWithValue }) => {
  try {
    const response = await tagsAPI.fetchMatched(arg);

    return response;
  } catch (e) {
    return rejectWithValue(false);
  }
});

export const fetchStartTags = createAsyncThunk<
  TagsResponse,
  string,
  { rejectValue: boolean }
>('tags/fetchStartTags', async (arg, { rejectWithValue }) => {
  try {
    const response = await tagsAPI.fetchStartTags(arg);

    return response;
  } catch (e) {
    return rejectWithValue(false);
  }
});

export const editTag = createAsyncThunk<
  Tags,
  EditTagRequest,
  { rejectValue: boolean }
>('tags/editTag', async (args, { rejectWithValue }) => {
  try {
    const response = await tagsAPI.editTag(args);

    return response;
  } catch (e) {
    return rejectWithValue(false);
  }
});

const initialState: TagsState = {
  topTags: {},
  result: null,
  startTags: {},
  isPending: {
    match: false,
    start: false,
  },
  page: null,
};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    dropResult: (state) => {
      state.result = null;
    },
    dropStartTags: (state) => {
      state.startTags = {};
    },
  },
  extraReducers: (builder) => {
    // All
    builder.addCase(fetchAllTags.pending, (state) => {
      state.result = null;
    });
    builder.addCase(fetchAllTags.fulfilled, (state, { payload }) => {
      state.page = payload;
    });

    // Top
    builder.addCase(fetchTopTags.pending, (state) => {
      state.result = null;
    });
    builder.addCase(fetchTopTags.fulfilled, (state, { payload }) => {
      state.topTags = payload.data;
    });

    // Start tags
    builder.addCase(fetchStartTags.pending, (state) => {
      state.isPending.start = true;
    });
    builder.addCase(fetchStartTags.fulfilled, (state, { payload }) => {
      state.startTags = payload.data;
      state.isPending.start = false;
    });
    builder.addCase(fetchStartTags.rejected, (state) => {
      state.isPending.start = false;
    });

    // Match
    builder.addCase(fetchMatched.pending, (state) => {
      state.result = null;
      state.isPending.match = true;
    });
    builder.addCase(fetchMatched.fulfilled, (state) => {
      state.isPending.match = false;
    });
    builder.addCase(fetchMatched.rejected, (state) => {
      state.isPending.match = false;
    });

    // Редактирование
    builder.addCase(editTag.pending, (state) => {
      state.result = null;
    });
    builder.addCase(editTag.rejected, (state) => {
      state.result = {
        type: 'error',
        message: 'Упс, кажется, что-то пошло не так',
      };
    });
  },
});

export const { dropResult, dropStartTags } = tagsSlice.actions;

export const selectTopTags = (state: RootState) => state.tags.topTags;
export const selectTagsPage = (state: RootState) => state.tags.page;
export const selectStartTags = (state: RootState) => state.tags.startTags;
export const selectResult = (state: RootState) => state.tags.result;
export const selectIsPending = (state: RootState) => state.tags.isPending;

export default tagsSlice.reducer;
